/**
 * RA2 dist datepicker ja-JP locale and defaults.
 * Matches RA2 public/dist/datepicker.ja-JP.js and dist DEFAULTS.
 */

export const JA_JP = {
  format: 'yyyy年mm月dd日',
  formatMonth: 'yyyy年mm月',
  formatYear: 'yyyy年',
  days: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  daysShort: ['日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'],
  daysMin: ['日', '月', '火', '水', '木', '金', '土'],
  months: [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月',
  ],
  monthsShort: [
    '01月',
    '02月',
    '03月',
    '04月',
    '05月',
    '06月',
    '07月',
    '08月',
    '09月',
    '10月',
    '11月',
    '12月',
  ],
  weekStart: 1,
  yearFirst: true,
  yearSuffix: '年',
} as const;

/** View enum: 0 = days, 1 = months, 2 = years */
export const VIEWS = { DAYS: 0, MONTHS: 1, YEARS: 2 } as const;

/** Years range: viewYear + start ... viewYear + end (dist uses -18 and 1) */
export const YEARS_RANGE = { start: -18, end: 1 };

/** Boundary years to prevent invalid navigation (Meiji era start = 1868, upper display bound = Reiwa 43) */
export const YEAR_BOUNDARIES = { min: 1868, max: 2061 };
